import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';

/** Circular Loader Component */
@customElement('te-loader')
export class TeLoader extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .determinate-loader {
        transform: rotate(-90deg);
        transition: 300ms linear all;
      }

      .indeterminate-loader {
        animation: indeterminate 2s linear infinite;
      }

      @keyframes indeterminate {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ];
  /** Uniform size of loader */
  @property({ type: Number }) size: 16 | 24 | 32 | 40 = 24;
  /** Progress value between 0 and 100 */
  @property({ type: Number }) progress?: number;

  getCircumference() {
    const normalizedRadius = (this.size - this.getStroke()) / 2;
    return normalizedRadius * 2 * Math.PI;
  }

  getStroke() {
    return this.size === 16 ? 2 : 4;
  }

  render() {
    const isDeterminate = this.progress !== undefined;
    const progress = this.progress || 0;
    return html`
      <svg
        height="${this.size}"
        width="${this.size}"
        class=${isDeterminate ? 'determinate-loader' : 'indeterminate-loader'}
      >
        <circle
          stroke="${theme.colors.shade3}"
          stroke-width="${this.getStroke()}"
          fill="none"
          r="${(this.size - this.getStroke()) / 2}"
          cx="${this.size / 2}"
          cy="${this.size / 2}"
        />

        <circle
          stroke="${theme.colors.primary.v0}"
          stroke-dasharray="${this.getCircumference()}"
          stroke-linecap="round"
          style="stroke-dashoffset:${(this.getCircumference() *
            (isDeterminate ? 100 - progress : 80)) /
          100}"
          stroke-width="${this.getStroke()}"
          fill="none"
          r="${(this.size - this.getStroke()) / 2}"
          cx="${this.size / 2}"
          cy="${this.size / 2}"
        />
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-loader': TeLoader;
  }
}
